import React from 'react';
import { badgePropTypes } from './BadgePropTypes';
import * as styles from './Badge.module.scss';
const Badge = ({
  badge,
  classname
}) => {
  if (!badge) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${classname || null}`
  }, badge);
};
export default Badge;